<div *ngIf="isConfirmed==false" style="padding:8px 8px">
    <h2>Forgot your password?</h2>
    <h4>Enter your email.</h4>
    <form asp-action="ForgotPassword" method="post">
        <div asp-validation-summary="All" class="text-danger"></div>
        <div class="pds-form-field">
            <label class="pds-form-label">Email</label>
            <dx-text-box class="pds-form-value" [(ngModel)]="email" name="email" asp-for="Email"></dx-text-box>
            <span asp-validation-for="Email" class="text-danger"></span>
        </div>
        <br />
        <dx-button [useSubmitBehavior]="true" type="default" (click)="buttonClick()" class="btn btn-default" text="Submit"></dx-button>
    </form>
</div>
<div *ngIf="isConfirmed==true">
    <h2>Forgot password confirmation</h2>
    <p>
        Please check your email to reset your password.
    </p>
</div>
